import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';

import { FetchPostsAction, PostState, SetFiltersAction, Where } from '@dcs-libs/shared';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  standalone: false
})
export class FilterComponent implements OnInit {
  private store = inject(Store);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  filter = '';

  filterForm = new UntypedFormGroup({
    filter: new UntypedFormControl('')
  });

  resetTime = new Subject();

  ngOnInit(): void {
    this.extractParams();
  }

  extractParams() {
    this.filter = this.route.snapshot.queryParamMap.get('filter') || '';
    this.filterForm.controls['filter'].setValue(this.filter);

    this.dispatchNewFilter({ title: { contains: this.filter } });
  }

  filterChange() {
    this.resetTime.next(true);
    timer(1000)
      .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.resetTime))
      .subscribe(() => {
        this.changeFilter();
      });
  }

  changeFilter() {
    if (this.checkIfFilterChange()) {
      this.filter = this.filterForm.controls['filter'].value;

      this.dispatchNewFilter({ title: { contains: this.filter } });
    }
  }

  dispatchNewFilter(newFilters: { title: { contains: string } }) {
    const filter = {
      ...(this.store.selectSnapshot(PostState.where) || {}),
      ...newFilters
    } as Where;
    this.store
      .dispatch(new SetFiltersAction(filter))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.store.dispatch(new FetchPostsAction());
        this.updateRoute();
      });
  }

  updateRoute() {
    const queryParams = {} as Params;
    if (this.filter !== '') {
      queryParams['filter'] = this.filter;
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: null,
      queryParams
    });
  }

  checkIfFilterChange(): boolean {
    return this.filter !== this.filterForm.controls['filter'].value;
  }
}
